import {
    handleConversationInitialization,
    handleGetConversationBySid
} from "~/modules/Conversation/ConversationErrorUtils";
import { ConversationsSdkImpl } from "~/modules/conversations/ConversationsSdkImpl";
import { Action } from "~/modules/actions/Action";
import { ContextInstance, ContextManager } from "~/modules/contextManager/ContextManager";
import { getLogger, LoggerName } from "~/modules/logger";
import { TaskRouterImpl } from "~/packages/taskrouter/TaskRouterImpl";
import { AnalyticsImpl } from "~/modules/telemetry/AnalyticsImpl";
import { EVENTS } from "~/modules/telemetry/Analytics";
import { Conversation } from "~/modules/Conversation";
import { checkRequiredParameter } from "~/modules/actions/ActionUtils";





























export class GetConversationBySid implements Action<Promise<Conversation>> {
    


    readonly #conversationSid: string;

    constructor(conversationSid: string) {
        this.#conversationSid = conversationSid;
    }

    



    async run(ctx: {}): Promise<Conversation> {
        const context = ctx as ContextManager;
        const logger = getLogger(context)(LoggerName.Actions);

        const taskRouter = context.retrieveInstanceOf(ContextInstance.TaskRouter, TaskRouterImpl);
        const conversations = context.retrieveInstanceOf(ContextInstance.ConversationsSdkImpl, ConversationsSdkImpl);
        const analytics = context.retrieveInstanceOf(ContextInstance.AnalyticsImpl, AnalyticsImpl);

        await taskRouter.init();
        const worker = taskRouter.worker;

        checkRequiredParameter(this.#conversationSid, "conversationSid", {
            actionName: "GetConversationBySid",
            moduleName: "actions/Conversation",
            worker,
            analytics,
            context,
            event: EVENTS.GetConversationBySidCompleted,
            extra: { conversationSid: this.#conversationSid },
            logger
        });

        await handleConversationInitialization(conversations, {
            actionName: "GetConversationBySid",
            moduleName: "actions/Conversation",
            worker,
            analytics,
            context,
            event: EVENTS.GetConversationBySidCompleted,
            extra: { conversationSid: this.#conversationSid },
            logger
        });

        return handleGetConversationBySid(conversations, this.#conversationSid, context, {
            actionName: "GetConversationBySid",
            moduleName: "actions/Conversation",
            worker,
            analytics,
            context,
            event: EVENTS.GetConversationBySidCompleted,
            extra: { conversationSid: this.#conversationSid },
            logger
        });
    }
}
